<template>
  <el-container  style="display: block;">

    <el-row  class="elementsz" style="margin-top: 30px;margin-left: 30px;">
      <template>
        <el-table
      	:data="tableData"
        :cell-class-name="addclass"
        height="1500"
        width='2780'
      	border
      	style="width: 2780px;height: 800px;text-align: center;margin: 0;">

        <el-table-column
          width="200"
          label="名字"
           >
           <template slot-scope="scope">
               <div>{{scope.row.gname}}</div>



           </template>
        </el-table-column>
        <el-table-column
          width="200"
          label="设备ID"
           >
           <template slot-scope="scope">
               <div>{{scope.row.shebeiid}}</div>


           </template>
        </el-table-column>
        <el-table-column
          width="400"
          label="模块"
           >
           <template slot-scope="scope">
               <div  @click="changeT(40,scope.row.mokuai,scope.row.id)">{{scope.row.mokuai}}</div>

           </template>
        </el-table-column>
        

        </el-table>
      </template>

    </el-row>

    <el-dialog
      title="修改"
      :visible.sync="centerDialogVisible"
      width="30%"
      center>
      <input type="text" class="searchT" v-model="changes"/>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="centerDialogVisible = false">取 消</el-button>
    	<el-button type="primary" @click="doChange()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改发音人"
      :visible.sync="fashengxuanze"
      width="30%"
      center>
      <el-select v-model="fayin"   filterable placeholder="请选择" >
          <el-option
            v-for="item in baoshanArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="fashengxuanze = false">取 消</el-button>
    	<el-button type="primary" @click="dochangefayin()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="修改语言"
      :visible.sync="zhxuanze"
      width="30%"
      center>
      <el-select v-model="zh"   filterable placeholder="请选择" >
          <el-option
            v-for="item in zhArr"
            :key="item"
            :label="item"
            :value="item">
          </el-option>
        </el-select>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="zhxuanze = false">取 消</el-button>
    	<el-button type="primary" @click="dochangezh()">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisibled"
      width="30%"
      >
      <span>确认删除？</span>
      <span slot="footer" class="dialog-footer">
    	<el-button @click="dialogVisibled = false">取 消</el-button>
    	<el-button type="primary" @click="doDell()">确 定</el-button>
      </span>
    </el-dialog>
  </el-container>

</template>

<script>

  export default {
    data() {
       return {
         zhArr:[],
         dialogVisibled:false,
         baoshanArr:['M','馨馨','宁宁','John','楠楠','小燕','许久','小萍','小婧','许小宝','小桃丸','小月','miya','艾伯哈','千惠','芳芳','suparut','中村','宋宝宝','小鹏','小兰','小雅','俄语女','法语女','西班牙语女','阿拉伯语女','维吾尔语女','哈萨克语女','波兰语女','意大利语女','德语女','葡萄牙语女','巴西葡萄牙语女'],
         fayin:'M',
         fashengxuanze:false,
         centerDialogVisible:false,
         changes:'',
         tableData:[],
         t:0,
         c_id:0,
         name:'0',
         xinghao:'0',
         yuncun:'0',
         chuliqi:'0',
         fenbianlv:'0',
         chicunbili:'M',
         'beizhu':'备注',
         'T1':'M',
         'yuansubeishus':'M',
         'tongyong':'M',
         'tongyongs':'M',
         'jingzhun':'M',
         'jingzhuns':'M',
         'neibu':'M',
         'neibus':'M',
         'biaoshi':'M',
         'biaoshis':'M',
         'yiban':'M',
         'yibans':'M',
         'diqu':'M',
         'diqus':'M',
         'dianxiansb':'M',
         'dianxiansbs':'M',
         'dianxianzb':'M',
         'dianxianzbs':'M',
         'tufa':'M',
         'tufas':'M',
         'yuansushangxian':'M',
         'yuansubeishu':'M',
         'lxbeishu':'M',
         'lxbeishus':'M',
         'fxbeishu':'M',
         'fxbeishus':'M',
         'xuanfutu':'M',
         'fyId':0,
         'dellId':0,
         'zhId':0,
         'zh':'中文',
         'zhxuanze':false,

      }
    },
	directives: {
    },
    created() {

      if(!window.localStorage.getItem('id')){
        this.$router.push({ path: '/' })
      }
      this.loadData();
      this.loadDatazh();
    },

	methods:{


    moveT(scw,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          scw:scw
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentMove'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '移动成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    copy(id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentCopy'
      })
      .then(res=>{
        this.$message({
        	type: 'sucsess',
        	message: '复制成功'
        });
         this.loadData()

      })
      .catch(err=>{

      });
    },
    dell(id){
      this.dellId = id
      this.dialogVisibled = true
    },
    doDell(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.dellId,

      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentDell'
      })
      .then(res=>{
         this.loadData()
         this.dialogVisibled = false
      })
      .catch(err=>{

      });
    },
    changezh(zh,id){
      this.zhId = id
      this.zh = zh
      this.zhxuanze = true
    },
    changefy(fayin,id){
      this.fyId = id
      this.fayin = fayin
      this.fashengxuanze = true
    },
    dochangefayin(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.fyId,
          name:this.fayin
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentChangefy'
      })
      .then(res=>{
         this.loadData()
         this.fashengxuanze = false
      })
      .catch(err=>{

      });
    },
    dochangezh(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.zhId,
          name:this.zh
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentChangezh'
      })
      .then(res=>{
         this.loadData()
         this.zhxuanze = false
      })
      .catch(err=>{

      });
    },
    addclass(row){

      if (row.columnIndex==7) {
          return 'yuansushangxian'

      }

    },
    changeT(t,n,id){
      this.c_id = id
      this.t = t
      this.changes = n
      this.centerDialogVisible = true
    },
    changekg(t,type,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          t:t,
          type:type
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentChangekg'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    doChange(){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:this.c_id,
          t:this.t,
          n:this.changes
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentChange'
      })
      .then(res=>{
         this.centerDialogVisible = false
         this.c_id = 0
         this.t = ''
         this.changes = ''
         this.loadData()

      })
      .catch(err=>{

      });
    },
    kg(p,id){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          id:id,
          p:p,
          t:1
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/statusChangequ'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    add(){

      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
          name:this.name,
          xinghao:this.xinghao,
          yuncun:this.yuncun,
          chuliqi:this.chuliqi,
          fenbianlv:this.fenbianlv,
          chicunbili:this.chicunbili,
          beizhu:this.beizhu,
          T1:this.T1,
          yuansushangxian:this.yuansushangxian,
          tongyong:this.tongyong,
          tongyongs:this.tongyongs,
          jingzhun:this.jingzhun,
          jingzhuns:this.jingzhuns,
          neibu:this.neibu,
          neibus:this.neibus,
          biaoshi:this.biaoshi,
          biaoshis:this.biaoshis,
          yiban:this.yiban,
          yibans:this.yibans,
          diqu:this.diqu,
          diqus:this.diqus,
          dianxiansb:this.dianxiansb,
          dianxiansbs:this.dianxiansbs,
          dianxianzb:this.dianxianzb,
          dianxianzbs:this.dianxianzbs,
          tufa:this.tufa,
          tufas:this.tufas,
          yuansubeishu:this.yuansubeishu,
          yuansubeishus:this.yuansubeishus,
          lxbeishu:this.lxbeishu,
          lxbeishus:this.lxbeishus,
          fxbeishu:this.fxbeishu,
          fxbeishus:this.fxbeishus,
          xuanfutu:this.xuanfutu,
          scw:4,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/equipmentAdd'
      })
      .then(res=>{
         this.loadData()

      })
      .catch(err=>{

      });
    },
    loadData(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:4,
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/equipmentList'
    	})
    	.then(res=>{
    		this.tableData = res.data;


    	})
    	.catch(err=>{

    	});
    },
    loadDatazh(){
    	const axiosInstance = this.$axios.create({
    		headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
    		withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
    	});
    	axiosInstance({
    		method:'get',
    		params:{
          scw:4,
    		},
    		url:'http://fencip.yoooooo.com/index.php/index/data/equipmentListzh'
    	})
    	.then(res=>{
    		this.zhArr = res.data;


    	})
    	.catch(err=>{

    	});
    },
    msg(msg,type){
    	this.$message({
    	  message: msg,
    	  type: type
    	});
    },

	}


  }
</script>

<style>
  .pai{
    background-color:rgb(64, 158, 255);
  }
  .yuansushangxian{
    font-weight: 700;
  }
</style>



// WEBPACK FOOTER //
// src/components/main/equipmentzf.vue